import React, { useState } from "react";
import {
  Card as MuiCard,
  CardContent,
  Typography,
  Button as MuiButton,
  Box,
  Collapse,
} from "@mui/material";
import styled from "styled-components";
import { format } from "date-fns";
import { marked } from "marked";
import DOMPurify from "dompurify";

const Card = styled(MuiCard)`
  background-color: #1b1a2ea9;
  color: white;
  box-shadow: 0 4px 5px 3px rgba(119, 53, 136, 0.459);
  transition: all 0.5s ease 0.5s;
  &:hover {
    ${"" /* transform: scale(1.02); */}
    box-shadow: 0 4px 4px 5px rgba(129, 72, 144, 0.561);
  }
`;

const DateTypography = styled(Typography)`
  font-size: 1rem;
  text-align: right;
  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
  color: var(--imp-text-color);
`;

const TitleTypography = styled(Typography)`
  font-size: 1.5rem;
  @media (max-width: 768px) {
    font-size: 1.025rem;
  }
  font-weight: 500;
  color: white;
`;

const LinkToResourceButton = styled(MuiButton)`
  background-color: #623686;
  color: #fff;
  &:hover {
    background-color: #6d20c5d7;
  }
`;

const ContentBox = styled(Box)`
  color: white;
  white-space: normal;
  text-align: left;
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-style: normal;
  letter-spacing: 0.5px;
  word-spacing: 1px;
  font-size: 1.2rem;
  @media (max-width: 768px) {
    font-size: 0.725rem;
  }
  /* Remove margin and padding from paragraphs or line breaks */
  p {
    margin: 0;
    padding: 0.35rem;
    @media (max-width: 768px) {
      padding: 0rem;
    }
  }
  h3 {
    @media (max-width: 768px) {
      font-size: 0.9rem;
    }
  }
  h4 {
    @media (max-width: 768px) {
      font-size: 0.8rem;
    }
  }
  h5,
  h6 {
    @media (max-width: 768px) {
      font-size: 0.7rem;
    }
  }
  br {
    margin: 0;
    padding: 0.5rem;
    @media (max-width: 768px) {
      padding: 0rem;
    }
  }
`;

const ExpandableCard = ({ date, title, text, link }) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const formatDate = (date) => {
    return format(new Date(date), "EEE, do MMM yyyy: h:mma");
  };

  // Convert Markdown to HTML
  const createMarkup = (markdownText) => {
    const html = marked(markdownText);
    return { __html: DOMPurify.sanitize(html) };
  };

  return (
    <Card>
      <CardContent>
        <div onClick={handleExpandClick}>
          <TitleTypography>{title}</TitleTypography>
          <DateTypography>{formatDate(date)}</DateTypography>
        </div>
        <Collapse
          in={expanded}
          timeout="auto"
          unmountOnExit
          style={{ paddingTop: "0.5rem" }}
        >
          <Box display="flex" justifyContent="center">
            <ContentBox dangerouslySetInnerHTML={createMarkup(text)} />
          </Box>
          <Box display="flex" justifyContent="flex-end">
            {link !== "" && (
              <LinkToResourceButton href={link} target="_blank">
                Resource Link
              </LinkToResourceButton>
            )}
          </Box>
        </Collapse>
      </CardContent>
    </Card>
  );
};

export default ExpandableCard;
